import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { InputText } from 'primeng/inputtext';
import { KeyFilter } from 'primeng/keyfilter';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface TextFieldProps extends FormlyFieldProps {
  pKeyFilter?: 'int' | 'num' | 'money' | 'hex' | 'alpha' | 'alphanum' | RegExp;
  hint?: string;
}

@Component({
  selector: 'text-field',
  standalone: true,
  imports: [...FORM_IMPORTS, KeyFilter, InputText],
  template: `
    <input
      pInputText
      [type]="'text'"
      [formControl]="formControl"
      autocomplete="false"
      [formlyAttributes]="field"
      [pKeyFilter]="props.pKeyFilter"
      class="w-full"
      (blur)="(props.blur)"
      aria-describedby="textinput"
    />
    @if (props.hint) {
      <small class="ml-[var(--p-inputtext-padding-x)]" id="textinput">{{
        props.hint
      }}</small>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldType extends FieldType<FieldTypeConfig<TextFieldProps>> {}
